import React from 'react';
import {currentResource, labels} from '../../../../util/utils';
import AssociatedRiskItem from './AssociatedRiskItem';

const AssociatedRiskList = (props) => {
	if (props.associatedRisksSummary.length === 0) {
		return <span className="no-risk">{labels.assessRisksNoItemsFound}</span>;
	}

	return (
		<ul className="AssociatedRiskListUL">
			{props.associatedRisksSummary.map((x) => {
				return (
					<li className="AssociatedRiskListLI">
						<span className="risk-type">{currentResource.aresRiskTypes[x.id - 1].name}</span>
						<ul className="risktype-list">
							{x.risks.length > 0 ? (
								<AssociatedRiskItem risks={x.risks} />
							) : (
								<span className="no-risk">
									{labels.noRisksIdentifiedForTheSpecificRiskType.replace(
										'{0}',
										currentResource.aresRiskTypes[x.id - 1].name
									)}
								</span>
							)}
						</ul>
					</li>
				);
			})}
		</ul>
	);
};

export default AssociatedRiskList;
